import FormViewForm from '@src/components/_forms/FormViewForm';
import {IClientModel} from '@src/@interfaces/models/Client/IClientModel';
import ClientContactsField from './fields/ClientContactsField';
import ClientOrdersField from './fields/ClientOrdersField';

const customFields = {
    contacts: {
        component: ClientContactsField,
    },
    orders: {
        component: ClientOrdersField,
    },
};

export default class ClientForm<Model extends IClientModel> extends FormViewForm<Model> {
    protected get customFields() {
        return customFields;
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (fieldName === 'contacts') {
            return this.getContractsFieldInitialValue();
        }

        return super.mutateModelFieldInitialValue(fieldName, modelValue);
    }

    private getContractsFieldInitialValue() {
        return this.props.model?.contacts?.map(contact => ({
            id: contact.id,
            type: contact.type,
            value: contact.value,
        }));
    }
}
